<template>
  <div class="mx-auto" :class="extraContainerClass">
    <div class="flex items-center">
      <h4 class="flex-1 text-left">
        {{ title }}
      </h4>

      <button type="button" @click="$emit('close')">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_close"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['formData', 'forceShowDatePicker', 'forceShowGuestsPicker']),
    hasMissingDate () {
      return this.formData.date === null || this.forceShowDatePicker
    },
    hasMissingGuests () {
      return this.formData.guests === '0' || this.forceShowGuestsPicker
    },
    hasFullInfo () {
      return !this.hasMissingDate && !this.hasMissingGuests
    },
    extraContainerClass () {
      if (this.hasFullInfo) {
        return 'w-full'
      }
      else {
        return 'container-md-400'
      }
    },
    title () {
      if (this.hasMissingDate) { 
        return 'Select date'
      }
      if (this.hasMissingGuests) {
        return 'Add travelers'
      }

      return 'Your trip'
    }
  }
}
</script>
